var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-carousel',{staticStyle:{"height":"400px"},attrs:{"interval":5000,"arrow":"always"}},_vm._l((_vm.sliders),function(slider){return _c('el-carousel-item',{key:slider,staticStyle:{"height":"400px"}},[_c('div',{staticClass:"imgSlider",style:({ 'background': 'url(' + slider + ')' })})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74424cdf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xd-swiper.vue
// module id = null
// module chunks = 